import React from "react"
import { Route } from "react-router-dom"
import { QaQcSampleTestGrid } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-test-grid';
import { QaQcSampleTest } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-test';
import { LabellingGrid } from '@gtpl/pages/qa-qc/qa-qc-components/labelling-grid';
import { LabellingForm } from '@gtpl/pages/qa-qc/qa-qc-components/labelling-form';
import { FgInspectionPrint } from '@gtpl/pages/qa-qc/qa-qc-components/fg-inspection-print';
import { FgInspectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/fg-inspection-form';
import { InspectionPrint } from '@gtpl/pages/qa-qc/qa-qc-components/product-inspection-print';
import { InspectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/product-inspection-form';
import { PdQaqcPrint } from '@gtpl/pages/production-management/production-management-components/peeling-preparation-print';
import { PdQaqcForm } from '@gtpl/pages/production-management/production-management-components/peeling-preparation-form';
import { MetalDetection } from '@gtpl/pages/qa-qc/qa-qc-components/metal-detection';
import { MetalDetectionForm } from '@gtpl/pages/qa-qc/qa-qc-components/metal-detection-form';
import { SoInspectionGrid } from '@gtpl/pages/inspection/inspection-components/so-inspection-grid';
import { CodeListAllocationGrid, CodeListMainGrid } from '@gtpl/pages/planning/planning-components/code-list-main-grid';
import { CodeListMainForm } from '@gtpl/pages/planning/planning-components/code-list-main-form';
import { QcDefectDetailsForm } from '@gtpl/pages/production-management/production-management-components/qc-defect-details-form';
import { QcDefectDetailsGrid } from '@gtpl/pages/production-management/production-management-components/qc-defect-details-grid';
import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import AntibioticsForm from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/antibiotics-form";
import AntiBioticsView from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/qaqc-analysis-view";
import QaqcDetailsView from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/qaqc-details-view";
import QAQCProductsCountView from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/qaqc-products-count-view";
import QAQCProductsCount from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/qaqc-products-count";
import QCClearance from "libs/pages/qa-qc/qa-qc-components/labelling-form/src/lib/qc-clearance";

export const QaQcRouting = () => {
  return (
    <>
       {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS))&&
       <>
            <Route exact path="/qa-qc-sample-test-grid" component={QaQcSampleTestGrid} />
       </>}
       {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON))&&
       <>
              <Route exact path="/code-list-main-form" component={CodeListMainForm} />
       </>}

       {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON)) &&
         <>
       <Route exact path="/antibiotics-form" component={AntibioticsForm} />  
       <Route exact path ="/antibiotics-view" component = {AntiBioticsView}/>
       <Route exact path ="/qaqc-analysis-view" component = {QaqcDetailsView}/>
       <Route exact path ="/qaqc-products-count" component = {QAQCProductsCount}/>
       <Route exact path ="/qaqc-products-count-view" component = {QAQCProductsCountView}/>
       <Route exact path ="/qc-clearance" component = {QCClearance}/>
       </>
       }
      <Route exact path="/qa-qc-sample-test" component={QaQcSampleTest} />
      <Route exact path="/labelling-grid" component={LabellingGrid} />
      <Route exact path="/labelling-form" component={LabellingForm} />
      <Route exact path="/fg-inspection-print" component={FgInspectionPrint} />
      <Route exact path="/fg-inspection-form" component={FgInspectionForm} />
      <Route exact path="/inspection-print" component={InspectionPrint} />
      <Route exact path="/inspection-form" component={InspectionForm} />
      <Route exact path="/pd-qaqc-print" component={PdQaqcPrint} />
      <Route exact path="/pd-qaqc" component={PdQaqcForm} />
      <Route exact path="/metal-detection-grid" component={MetalDetection} />
      <Route exact path="/metal-detection-form" component={MetalDetectionForm} />
      <Route exact path="/so-inspection" component={SoInspectionGrid} />
      <Route exact path="/qcdefect-view" component={QcDefectDetailsGrid} />
      <Route exact path="/qcdefect-form" render={props => <QcDefectDetailsForm qcdefectData={undefined}
        isUpdate={false}
        closeForm={() => { }}
        updateItem={(undefined) => { }}
      />}
      />
    

      {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) ||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON))&&
      <>
       <Route exact path="/code-list-main-grid" component={CodeListAllocationGrid} />
      </>}
     
    </>
  )
}